import { useSelector } from 'react-redux';
import ProviderCommonApi from '../../../API/provider/common-api';
import RelefApi from '../../../API/provider/relef-api';
import ProviderProductsTable from '../../../components/Providers/Blocks/ProductsTable';
import ProviderDasboardContentWhiteBlock from '../../../components/Providers/Blocks/ProviderDasboardContent';
import ProviderUpdateStatusBlock from '../../../components/Providers/Blocks/ProviderUpdateStatus';
import { PROVIDERS, TYPE_BUTTONS } from '../../../constans';
import { Content } from '../../../components/Basic/Global';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button } from '../../../components/Basic/Buttons';

const RelefPage = ({ ...props }) => {
  const user = useSelector((store) => store.user);

  const providerId = PROVIDERS.RELEF.id;

  const loadProducts = async () => {
    await RelefApi.loadProducts({})
  };

  const access = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <Row>
          <WhiteBlock title="Остатки">
            <Column style={{ marginBottom: '15px' }}>
              <Row>
                <Button type={TYPE_BUTTONS.BLUE} onClick={loadProducts} style={{ marginRight: '15px' }}>
                  Обновить остатки
                </Button>
                {access && (
                  <Row style={{ alignItems: 'flex-start' }}>
                    <Button
                      type={TYPE_BUTTONS.RED}
                      onClick={() => ProviderCommonApi.nullStocks({ data: { providerId } })}
                      style={{ marginRight: '15px' }}
                    >
                      Обнулить остатки
                    </Button>
                  </Row>
                )}
              </Row>

              <ProviderUpdateStatusBlock providerId={providerId} />
            </Column>
          </WhiteBlock>

          <ProviderDasboardContentWhiteBlock providerId={providerId} />
        </Row>

        <ProviderProductsTable providerId={providerId} isMinPackage={true} />
      </Content>
    </>
  );
};

export default RelefPage;
